var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.requiredField)?_c('b-form-select',{staticClass:"select-field",attrs:{"options":_vm.optionsBoolean},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }